import React, { useContext, useState } from "react";
import { TableHead } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ExpandMore } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import PartsInformation from "./PartsInformation";
import language from '../../../nls/language.json';
import Context from "../../../context/Context";
import './styles/AdditionalInformation.css'

function AdditionalInformation({
  data,
  sagA_Pecas,
  sagA_Tool,
  sagA_GlassLot,
  sagA_MoldesGalgas,
  sagA_Components
}) {
  const [expanded, setExpanded] = useState(false);
  const {
    selectedCountry,
  } = useContext(Context);

  var style = {
    padding: 0.6,
    textAlign: "center",
    whiteSpace: "nowrap",
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Aguarda todas as props chegarem antes de renderizar
  const isLoading =
    !data ||
    !Array.isArray(sagA_Pecas) ||
    !Array.isArray(sagA_Tool) ||
    !Array.isArray(sagA_GlassLot) ||
    !Array.isArray(sagA_MoldesGalgas) ||
    !Array.isArray(sagA_Components);

  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "40px" }}>
        <CircularProgress size={100} />
      </div>
    );
  }

  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="header-flex accordionSummary"
        >
          <p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.informacoesDaPeca.title}</p>
        </AccordionSummary>
        <AccordionDetails>
          <PartsInformation data={data} />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="header-flex accordionSummary"
        >
          <p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.title}</p>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0 }}>
          {sagA_Pecas.length === 0 ? (
            <h2>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.semInformacoes}</h2>
          ) : (
            <TableContainer
              component={Paper}
              sx={{ maxHeight: 400, overflow: "auto" }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.posicao}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.codMaterial}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.material}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.deposito}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.lote}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.grupoMat}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.Documento}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.Movimento}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.qtdeConsumo}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.pousuariosicao}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.materiaisConsumidos.tableHeader.dataHora}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sagA_Pecas.length &&
                    [...sagA_Pecas]
                      .sort((a, b) => a.ITEM_MATERIAL?.localeCompare(b.ITEM_MATERIAL))
                      .map((pecas, index) => (
                        <TableRow
                          key={index}
                          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                          <TableCell sx={style}>{pecas.Ordem_Material || ''}</TableCell>
                          <TableCell sx={style}>{pecas.COD_MATERIAL || ''}</TableCell>
                          <TableCell sx={style}>{pecas.MATERIAL || ''}</TableCell>
                          <TableCell sx={style}>{pecas.DEPOSITO || ''}</TableCell>
                          <TableCell sx={style}>{pecas.LOTE || ''}</TableCell>
                          <TableCell sx={style}>{pecas.GRUPO_MAT || ''}</TableCell>
                          <TableCell sx={style}>{pecas.DOCUMENTO || ''}</TableCell>
                          <TableCell sx={style}>{pecas.MOVIMENTO || ''}</TableCell>
                          <TableCell sx={style}>{pecas.QTDE_CONSUMO || ''}</TableCell>
                          <TableCell sx={style}>{pecas.USUARIO || ''}</TableCell>
                          <TableCell sx={style}>
                            {pecas.DT_LANCAMENTO_T && pecas.HR_LANCAMENTO_T
                              ? `${pecas.DT_LANCAMENTO_T} ${pecas.HR_LANCAMENTO_T}`
                              : ''}
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="header-flex accordionSummary"
        >
          <p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.serigrafia.title}</p>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0 }}>
          {sagA_Tool.length === 0 ? (
            <h2>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.semInformacoes}</h2>
          ) : (
            <TableContainer
              component={Paper}
              sx={{ maxHeight: 400, overflow: "auto" }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.serigrafia.tableHeader.codigo}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.serigrafia.tableHeader.descricao}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.serigrafia.tableHeader.localSaga}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.serigrafia.tableHeader.status}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!!sagA_Tool &&
                    sagA_Tool.map((tool, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell sx={style}>{tool.ferramental_Codigo}</TableCell>
                        <TableCell sx={style}>{tool.ferramental_Descricao}</TableCell>
                        <TableCell sx={style}>{tool.ferramental_LocalSAGA}</TableCell>
                        <TableCell sx={style}>{tool.ferramental_Status}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="header-flex accordionSummary"
        >
          <p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.vidros.title}</p>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0 }}>
          {sagA_GlassLot.length === 0 ? (
            <h2>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.semInformacoes}</h2>
          ) : (
            <TableContainer
              component={Paper}
              sx={{ maxHeight: 400, overflow: "auto" }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.vidros.tableHeader.codMaterial}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.vidros.tableHeader.material}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.vidros.tableHeader.lote}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.vidros.tableHeader.dataHora}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.vidros.tableHeader.usuario}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.vidros.tableHeader.qtdeConsumo}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.vidros.tableHeader.sets}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(sagA_GlassLot) && sagA_GlassLot.map((vidro, index) => (
                    <TableRow
                      key={index}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell sx={style}>{vidro.CD_CONTA_CONTABIL}</TableCell>
                      <TableCell sx={style}>{vidro.MATERIAL}</TableCell>
                      <TableCell sx={style}>{vidro.LOTE}</TableCell>
                      <TableCell sx={style}>{vidro.DT_HORA}</TableCell>
                      <TableCell sx={style}>{vidro.USUARIO}</TableCell>
                      <TableCell sx={style}>{vidro.QTDE_CONSUMO}</TableCell>
                      <TableCell sx={style}>{vidro.SETS}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {sagA_Components.length > 0 && (
            <>
              <p style={{ padding: "8px 16px", fontWeight: "bold", margin: 0 }}>
                Componentes de Corte
              </p>
              <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: "auto" }}>
                <Table stickyHeader aria-label="componentes table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={style}>Pos</TableCell>
                      <TableCell sx={style}>Cód. Material</TableCell>
                      <TableCell sx={style}>Nome</TableCell>
                      <TableCell sx={style}>ClaveModelo</TableCell>
                      <TableCell sx={style}>m²</TableCell>
                      <TableCell sx={style}>Un. Med</TableCell>
                      <TableCell sx={style}>Descrição Eng.</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sagA_Components.map((comp, index) => (
                      <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                        <TableCell sx={style}>{comp.pos}</TableCell>
                        <TableCell sx={style}>{comp.desenho_CodMat}</TableCell>
                        <TableCell sx={style}>{comp.desenho_Descricao}</TableCell>
                        <TableCell sx={style}>{comp.desenho_ClaveModelo}</TableCell>
                        <TableCell sx={style}>{comp.m2}</TableCell>
                        <TableCell sx={style}>{comp.unMed}</TableCell>
                        <TableCell sx={style}>{comp.descricao_Eng}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="header-flex accordionSummary"
        >
          <p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.moldesGalgas.title}</p>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0 }}>
          {sagA_MoldesGalgas.length === 0 ? (
            <h2>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.semInformacoes}</h2>
          ) : (
            <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.moldesGalgas.tableHeader.ordemSerial}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.moldesGalgas.tableHeader.tipo}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.moldesGalgas.tableHeader.posicao}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.moldesGalgas.tableHeader.codigo}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.moldesGalgas.tableHeader.grupo}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.moldesGalgas.tableHeader.descricao}</TableCell>
                    <TableCell sx={style}>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.info.moldesGalgas.tableHeader.ferramental}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sagA_MoldesGalgas.map((vidro, index) => (
                    <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell sx={style}>{vidro.ordem_Serial}</TableCell>
                      <TableCell sx={style}>{vidro.tipo}</TableCell>
                      <TableCell sx={style}>{vidro.posicao_Lista}</TableCell>
                      <TableCell sx={style}>{vidro.ferr_Codigo}</TableCell>
                      <TableCell sx={style}>{vidro.ferr_Grupo}</TableCell>
                      <TableCell sx={style}>{vidro.ferr_Descricao}</TableCell>
                      <TableCell sx={style}>{vidro.local_Ferramental}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default AdditionalInformation;